import { Module } from "vuex";
import type { RootState } from "@/store";

import {
  BRAND_MAPPING,
  BRANDS_CONFIG,
  defaultBrand,
  TypeBrand,
} from "@/config/brands";

export interface BrandState {
  operatorSource: TypeBrand;
}

const brandModule: Module<BrandState, RootState> = {
  namespaced: true,
  state: () => ({
    operatorSource: defaultBrand,
  }),
  getters: {
    configDataBrand: (state) =>
      BRANDS_CONFIG[state.operatorSource] || BRANDS_CONFIG[defaultBrand],
    configDataDefaultBrand: () => BRANDS_CONFIG[defaultBrand],
  },
  mutations: {
    SET_OPERATOR_SOURCE(state, value: TypeBrand) {
      state.operatorSource = value;
    },
  },
  actions: {
    updateOperatorSource({ commit }, value: TypeBrand) {
      commit("SET_OPERATOR_SOURCE", value);
    },
    removeOperatorSource({ commit }) {
      commit("SET_OPERATOR_SOURCE", defaultBrand);
    },
    syncOperatorBrand({ commit, state }, backendOperator: string | undefined) {
      if (!backendOperator) return;
      const targetSource = BRAND_MAPPING[backendOperator];

      if (targetSource && targetSource !== state.operatorSource) {
        commit("SET_OPERATOR_SOURCE", targetSource);
      }
    },
    ["auth/setAuth"]: {
      root: true,
      handler({ dispatch }, isAuth: boolean) {
        console.log(' ["auth/setAuth"]: ', isAuth);
        if (!isAuth) {
          dispatch("removeOperatorSource", null);
        }
      },
    },
  },
};

export default brandModule;
